// 引入共用資料
import comm_data from './../comm_data';
import comm_imgs from './../comm_imgs';
import ConfigHandler from './ConfigHandler';

/**
 * // ✎NOTE: ---------〖資料處理器 - 針對 mqtt bed alert〗---------
 *
 * @param {String} alert_level mwg/events bedStateAlertLevel
 * @param {String} alert_state mwg/events bedState
 * @returns {{level: string, img: string, msg: string}} { level: 顯示等級訊息(如：emergency、warning、normal), img: 指定顯示bedstate的圖片, msg: 狀態訊息(如：在床、準備離床…) }
 */
export default function dataHandler_alert(alert_level = '', alert_state = '') {
    const level = alert_level.toString();
    const state = alert_state ? alert_state.toString() : "";
    const isVITAL = ConfigHandler.isVital;
    if (level === "0" || level === "1" || level === "2" || level === "3") {
        const NEW_images = {
            "1": comm_imgs[`LEVEL_${level}`]["1_NO_IN_BED"],
            "4": comm_imgs[`LEVEL_${level}`]["4_IN_BED"],
            "7": comm_imgs[`LEVEL_${level}`]["7_left_lying"],
            "8": comm_imgs[`LEVEL_${level}`]["8_right_lying"],
            "12": comm_imgs[`LEVEL_${level}`]["12_SIT_UP"],
            "13": comm_imgs[`LEVEL_${level}`]["13_ENTER"],
            "14": comm_imgs[`LEVEL_${level}`]["14_EXIT"],
            "15": comm_imgs[`LEVEL_${level}`]["15_SIDE_LYING"],
            "203": comm_imgs[`LEVEL_${level}`]["203_HARNESSBREAK"],
            "206": comm_imgs[`LEVEL_${level}`]["206_TRANSCEIVER_OFFLINE"],
            "208": comm_imgs[`LEVEL_${level}`]["208_TRANSCEIVER_ONLINE"],

            "211": comm_imgs[`LEVEL_${level}`]["211_RESOLVE_ALERT_BY_BED"],
            "212": comm_imgs[`LEVEL_${level}`]["212_RESOLVE_ALERT_BY_STATION"],

            "217": comm_imgs[`LEVEL_${level}`]["217_LONG_STAY"],
            "218": comm_imgs[`LEVEL_${level}`]["218_LEAVING_OVERTIME"],

            "501": comm_imgs[`LEVEL_${level}`]["501_AWAKE_DETECTED"],
            "502": comm_imgs[`LEVEL_${level}`]["502_AWAKE_RESTLESS"],
            "503": comm_imgs[`LEVEL_${level}`]["503_AWAKE_EMERGE"],
            "504": comm_imgs[`LEVEL_${level}`]["504_AWAKE_ALREADY"], 
            "505": comm_imgs[`LEVEL_${level}`]["505_RESTLESS_CHECK"], 
            "511": comm_imgs[`LEVEL_${level}`]["511_MOBILITY_TOO_HIGH"],
            "512": comm_imgs[`LEVEL_${level}`]["512_MOBILITY_TOO_LOW"],

        };
        if (isVITAL) {
            NEW_images["103"] = comm_imgs[`LEVEL_${level}`]["103_RESPIRATORY"];
        }
        return {
            level: comm_data[`LEVEL_${level}`],
            img: NEW_images[state],
            msg: comm_data[`ALERT_STATE_${state}`]
        };
    } else {
        return "No such information";
    }
}